<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => pageTitle = val" />
            <!-- //breadcrumbs -->
            <h2 class="pg_title">{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap">
                <article class="srch_basic">
                    <div class="srch_grup">
                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.SUBSIDIARY')}}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset v-if="processLevel != '4'" class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="rhqCd" @change="changeRhqCd()">
                                            <option v-if="rhqCdList.length > 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="corpNo">
                                            <option v-if="corpNoList.length != 1" value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                </fieldset>
                                <fieldset v-if="processLevel == '4'" class="ui_fieldset">
                                    <div>
                                        <select class="slt_white w100" v-model="regDeptNo">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="code in departments" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.ADMIN.PROCESSIN.LEVEL')}}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="processLevel">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="item in processLevels" :key="item.code" :value="item.code">{{item.codeName}}</option
                                            >
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>

                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.INQUIRY.TYPE')}}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_2">
                                    <div>
                                        <select class="slt_white w100" v-model="inquiryCd1" @change="inquiryList(2)">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="item in inquiry1Codes" :key="item.CD"
                                                :value="item.CD">{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100" v-model="inquiryCd2">
                                            <option value="">{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                            <option v-for="item in inquiry2Codes" :key="item.CD"
                                                    :value="item.CD">{{ item.CD_NAME }}</option
                                            >
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.FAST.ADVANCED.MODEL')}}</li>
                            <li data-input-type="input" class="w100-150">
            					<label class="serach-btn-wrap">
                                    <span class="s_input">
                                        <input type="text" class="text_input w100" placeholder="Search" v-model="modelNm" disabled />
                                        <a href="JabaScript:" class="in_btn_search" @click="searchModelPopup()"><i class="ico_input_serach"></i><span class="sr_only">검색 열기</span></a>
                                    </span>
                                    <span class="s_btn"><a href="JavaScript:" @click="clickReset(1)" class="btn_white w100" title="">Reset</a></span>
                                </label>
                            </li>
                        </ul>

                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.CATEGORY')}}</li>
                            <li data-input-type="select" class="w100-150">
                                <fieldset class="ui_fieldset set_3">
                                    <div>
                                        <select class="slt_white w100p" id="prod1" v-model="prodCateCd1" @change="changeProdCd(1)">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                            <option v-for="code in prodCategories1" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" id="prod2" v-model="prodCateCd2" @change="changeProdCd(2)">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                            <option v-for="code in prodCategories2" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <select class="slt_white w100p" id="prod3" v-model="prodCateCd3">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                                            <option v-for="code in prodCategories3" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                    </div>
                                </fieldset>
                            </li>
                        </ul>
                        <ul class="w50">
                            <li class="tit_150">{{ $t('BUTTON.GLOBAL.REGISTER') }}</li>
                            <li data-input-type="input" class="w100-150">
            					<label class="serach-btn-wrap">
                                    <span class="s_input">
                                        <input type="text" class="text_input w100" placeholder="Search" v-model="registerNm" disabled />
                                        <a href="JabaScript:" class="in_btn_search" @click="searchUserPopup(1)"><i class="ico_input_serach"></i><span class="sr_only">검색 열기</span></a>
                                    </span>
                                    <span class="s_btn"><a href="JavaScript:" @click="clickReset(2)" class="btn_white w100" title="">Reset</a></span>
                                </label>
                            </li>
                        </ul>

                        <ul class="w50">
                            <li class="tit_150">{{$t('FIELD.GLOBAL.REGISTERED.DATE')}}<em class="txt_mandatory">*</em></li>
                            <dd data-input-type="date">
                                <fieldset class="ui_fieldset">
                                    <span class="date-wrap">
                                        <label>
                                            <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                            <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                        </label>
                                        <div id="from-picker-container" style="margin-top: -1px;"></div>
                                    </span>
                                    <em class="txt_space"></em>
                                    <span class="date-wrap">
                                        <label>
                                            <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                            <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                        </label>
                                        <div id="to-picker-container" style="margin-top: -1px;"></div>
                                    </span>
                                </fieldset>
                            </dd>
                        </ul>
                        <ul class="w50">
                            <li class="tit_150">{{ $t('TITLE.GLOBAL.ANSWERERS') }}</li>
                            <li data-input-type="input" class="w100-150">
            					<label class="serach-btn-wrap">
                                    <span class="s_input">
                                        <input type="text" class="text_input w100" placeholder="Search" v-model="answererNm" disabled />
                                        <a href="JabaScript:" class="in_btn_search" @click="searchUserPopup(2)"><i class="ico_input_serach"></i><span class="sr_only">검색 열기</span></a>
                                    </span>
                                    <span class="s_btn"><a href="JavaScript:" @click="clickReset(3)" class="btn_white w100" title="">Reset</a></span>
                                </label>
                            </li>
                        </ul>
                    </div>
                    <div class="srch_grupR_bottom">
                        <span class="btn">
                            <a href="javascript:" class="btn_srch" @click="onSearch(1)">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                        </span>
                    </div>
                </article>
            </div>
            <!-- Grid -->
            <div class="grid_wrap">
                <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{ totalCount | numberFormat }}</em></div>
                <div class="btn_wrap">
                    <a href="javascript:" class="btn_white" @click="excelDownload()">{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    ref="GridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :header="gridHeader"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div><!-- grid_wrap -->
        </div><!--contents_wrap -->
    </div><!-- contents -->
</template>

<script>
import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import qs                       from 'query-string';
import axios                    from 'axios';
import moment                   from 'moment';
import api                      from '@/service';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, DateUtil }    from '@/utils';
import { EventBus }             from '@/utils/EventBus';
import { HeaderHtmlRenderer }   from '~c/GridCustomRenderer';
import SKPBreadcrumbs           from '~vb/main/SKPBreadcrumbs';
import DatePicker               from '~c/DatePicker';
import ToastGrid                from '~c/ToastGrid';
import ExcelDownloadPopup       from '~vb/common/ExcelDownloadPopup';
import StstLinkPopup            from './StstLinkPopup';
import searchUserPopup          from '~va/qnaManager/popup/searchUserPop';
import searchModelPopup         from '~vb/faq/popup/searchModelPopup';

// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaReportByAnswerers.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

// ToastGrid  renderer
class ClassRenderer {
    constructor(props) {
        let rowKey = props.rowKey;
        let answerVal = props.grid.store.data.rawData[rowKey].ANSWERER;
        let resVal = props.value;
        const el = document.createElement('span');
        if (answerVal == 'Total') {
            el.className = "subTotal";
        } else if (resVal > 0) {
            el.className = "ftColor";
        }
        el.innerText = resVal;
        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

// ToastGrid Tooltip renderer
class TooltipRenderer {
    constructor(props) {
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = resVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name : 'reportByAnswer',
    props : {
    },
    data() {
        return {
            isProcess: true,
            loadingCnt: 0,
            rhqCd: '',
            corpNo: '',
            regDeptNo: '',
            processLevel: '',
            inquiryCd1: '',
            inquiryCd2: '',
            modelCd: '',
            modelNm: '',
            prodCateCd1: '',
            prodCateCd2: '',
            prodCateCd3: '',
            register: '',
            registerNm: '',
            answerer: '',
            answererNm: '',
            rhqCdList: [],
            corpNoList: [],
            departments: [],
            processLevels: [],
            inquiry1Codes: [],
            inquiry2Codes: [],
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],

            FROM_DATE: {},     // Knowledge date
            TO_DATE: {},       // View date

            searchParam: {},

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "GridId_QnA_RA",
            gridKey: 0,
            gridData : [],
            gridHeader: {
                columns: [
                    { name: 'ANS_RATE',  renderer: HeaderHtmlRenderer }
                  , { name: 'PENDING_CNT', renderer: HeaderHtmlRenderer }
                ],
                height: 60,
                complexColumns: [
                    {
                        header: 'On-Time Answer',
                        name: 'mergeColumn1',
                        childNames: ['TOTAL', 'D', 'D1', 'D2']
                    },
                    {
                        header: 'On-Time Feedback(%)',
                        name: 'mergeColumn2',
                        childNames: ['ONTIME_RATE_D1', 'ONTIME_RATE_D2']
                    },
                ]
            },
            columns : [
                {
                    header: SDLUtil.getMsgProp('TITLE.GLOBAL.ANSWERERS'),
                    name: "ANSWERER",
                    //width: 200,
                    align: "left",
                    sortable: false,
                    renderer: {type: TooltipRenderer},
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY'),
                    name: "INQUIRY_CNT",
                    align: "center",
                    width: 80,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ANSWER'),
                    name: "ANSWERER_CNT",
                    align: "center",
                    width: 80,
                    renderer: { type: ClassRenderer },
//                    className: 'ftColor',
                    sortable: false,
                    resizable: true,
                },
                {
                    header: 'Answer<br>Rate(%)',
                    name: "ANS_RATE",
                    width: 80,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TOTAL'),
                    name: "ANSWER_TOTAL",
                    width: 80,
                    align: "center",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D",
                    name: "D",
                    align: "center",
                    width: 70,
                    renderer: { type: ClassRenderer },
//                    className: 'ftColor',
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+1",
                    name: "D1",
                    align: "center",
                    width: 70,
//                    className: 'ftColor',
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D+2",
                    name: "D2",
                    align: "center",
                    width: 70,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.ACCEPTED'),
                    name: "ACCEPTED_CNT",
                    align: "center",
                    width: 80,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: 'Pending<br>for accept',
                    name: "PENDING_CNT",
                    align: "center",
                    width: 80,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INPROGRESS'),
                    name: "PRO_CNT",
                    align: "center",
                    width: 80,
                    renderer: { type: ClassRenderer },
                    sortable: false,
                    resizable: true,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.TOTALOPEN'),
                    name: "OPEN_TOTAL",
                    align: "center",
                    width: 80,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D + 1",
                    name: "ONTIME_RATE_D1",
                    align: "center",
                    width: 70,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "D + 2",
                    name: "ONTIME_RATE_D2",
                    align: "center",
                    width: 70,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "answerer",
                    name: "CHRG_USER_NO",
                    hidden: true
                }
            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 30 },
                rowHeight: 30,
            },
            pageOptions: {}
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            locale:     'getLocale',
            loginNo:    'getLoginNo',
            deptLevelCd: 'getDeptLevelCd',
            deptNo:     'getDeptNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        }
    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(mode, pCode) {
            if (mode == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.rhqCdList = data;
                    this.rhqCd = this.rhqCdList[0].code;
//                    if (this.rhqCdList.length == 1) this.rhqCd = this.rhqCdList[0].code;
//                    else                            this.rhqCd = '';
                    if (this.rhqCd) this.loadSubsiCodes(2, this.rhqCdList[0].code);
                });
                this.offLoadingBar();
            } else if (mode == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.corpNoList = data;
                    this.corpNo = this.corpNoList[0].code;
//                    this.corpNo = '';
                });
            }
        },
        changeRhqCd() {
            if (this.rhqCd == '') {
                this.corpNoList = [];
                this.corpNo = '';
            } else {
                this.loadSubsiCodes(2, this.rhqCd);
            }
        },
        loadProducts(depth, param, defVal, defVal3) {
            param.depth     = depth;
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/system/userRole/productCategories.skp`,
                qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                },
            ).then(resp => {
                if (depth == 1) { // product 1depth
                    this.prodCategories1 = resp.data;
                    this.prodCateCd1       = '';
                    param.parentCode     = resp.data[0].code;
                    this.loadProducts(2, param);
                    this.offLoadingBar();
                } else if (depth == 2) { // product 2depth
                    this.prodCategories2 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCateCd2   = '';
                        this.prodCateCd3   = '';
                    } else {
                        if (defVal) this.prodCate2 = defVal;
                        else        this.prodCate2 = '';
                        param.parentCode = resp.data[0].code;
                        if (defVal) this.loadProducts(3, param, true, defVal3);
                        else        this.loadProducts(3, param);
                    }
                } else if (depth == 3) { // product 3depth
                    this.prodCategories3 = resp.data;
                    if (defVal) this.prodCateCd3 = defVal3;
                    else        this.prodCateCd3 = '';
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        changeProdCd(depth) {
            if (depth == 1) { // product code - 1Depth
                if (this.prodCateCd1 == '') {
                    this.prodCategories2 = [];
                    this.prodCategories3 = [];
                    this.prodCateCd2 = '';
                    this.prodCateCd3 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCateCd1};
                    this.loadProducts(2, param);
                }
            } else if (depth == 2) { // product code - 2Depth
                if (this.prodCateCd2 == '') {
                    this.prodCategories3 = [];
                    this.prodCateCd3 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCateCd2};
                    this.loadProducts(3, param);
                }
            }
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.deptNo,
                        value: this.inquiryCd1,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        this.inquiry1Codes = resp.data.result.rowData;
                        if (this.inquiry1Code) this.inquiryList(2);
                    } else if (v === 2) {
                        this.inquiry2Code = '';
                        this.inquiry2Codes = resp.data.result.rowData;
                    }
                    this.offLoadingBar();
                });
        },
        getSearchParams() {
            const mFormat = localStorage.getItem('mDateFormat');
            let params = {
                rhqCd        : this.rhqCd,
                corpNo       : this.corpNo, // || $('#selectRhqSubCd').val(),
                regDeptNo    : this.regDeptNo,
                processLevel : this.processLevel,
                inquiryCd1   : this.inquiryCd1,
                inquiryCd2   : this.inquiryCd2,
                modelCd      : this.modelCd,
                prodCateCd1  : this.prodCateCd1,
                prodCateCd2  : this.prodCateCd2,
                prodCateCd3  : this.prodCateCd3,
                register     : this.register,
                answerer     : this.answerer,
//                strDate      : moment(this.FROM_DATE.getDate(), mFormat).format(mFormat).toString(),
//                endDate      : moment(this.TO_DATE.getDate(), mFormat).format(mFormat).toString()
                strDate      : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                endDate      : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
            };
            console.log('params ==> ', params);
            return params;
        },

        // 버튼 이벤트
        async onSearch(pageNo) {
            let validContents = this.registVerifyContents();
            const params = this.getSearchParams();
            if (validContents) {
                if (!pageNo) pageNo = 1;

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data.result;
                        this.totalCount = data.rowCount;
                        this.gridData   = data.rowData;
                        this.searchParam = res.data.searchParam;

                        this.$nextTick(() => {
                            this.$refs.GridId.addRowClassName(this.totalCount-1, 'subTotal');
//                            this.gridData.forEach((row, idx) => {
//                                if (row.ANSWERER == 'Total') {
//                                    this.$refs.GridId.addRowClassName(idx, 'sub_total');
//                                }
//                            });
                        });

                        this.gridKey++;
                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> Grid
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;

            let blockCols = '|ANSWERER|ANS_RATE|ANSWER_TOTAL|OPEN_TOTAL|ONTIME_RATE_D1|ONTIME_RATE_D2|';
            let row = rowData[e.rowKey];
            let value = Number(eval('row.' + colNm));
            if (value == 0) return;
            if (row.ANSWERER == 'Total') return;
            if (blockCols.indexOf('|' + colNm + '|') > -1) return;

            let typeNm = '';
            if (colNm == 'D') { typeNm = 'On-Time Answer D'; }
            else if (colNm == 'D1') { typeNm = 'On-Time Answer  D+1'; }
            else if (colNm == 'D2') { typeNm = 'On-Time Answer  D+2'; }
            else if (colNm == 'ACCEPTED_CNT') { typeNm = 'Accepted'; colNm = 'ACP'; }
            else if (colNm == 'PENDING_CNT') { typeNm = 'Pending for accept'; colNm = 'PEN'; }
            else if (colNm == 'PRO_CNT') { typeNm = 'In progress'; colNm = 'PRO'; }
            else if (colNm == 'ANSWERER_CNT') { typeNm = 'Answer'; colNm = 'END'; }
            else { typeNm = 'Inquiry'; }

            let params = this.searchParam;
            params.answerNo = row.CHRG_USER_NO;
//            params.answerer = row.ANSWERER;
//            params.typeName = typeNm;
            params.colName  = colNm;
            params.pageMode = '1'; // Q&A Report by Answerer
            params.url = `${SDLUtil.API_URL}/basis/admin/statisticsManager/reportByAnswerersPop.skp`;
            params.dynLabel1 = SDLUtil.getMsgProp('FIELD.USER.NAME');
            params.dynLabel2 = SDLUtil.getMsgProp('FIELD.GLOBAL.TYPE');
            params.dynValue1 = row.ANSWERER;
            params.dynValue2 = typeNm;
            params.btnShow = false;

            SDLUtil.show(
                StstLinkPopup,
                {
                    title: 'title',
                    pParams: params,
                    rtnUserFunc: (arg1) => {
                        console.log('arg1 ==> ', arg1);
                    }
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
        },
        // 엑셀 다운로드
        excelDownload() {
            const startDate = moment(this.rangePicker.getStartDate());
            const endDate = moment(this.rangePicker.getEndDate());
            const dateDiff = Math.abs(endDate.diff(startDate, 'days'));
            if (dateDiff > 31) {
                SDLUtil.alert({
                    title: 'Alert',
                    msg: 'Maximum Registered Date range for Export to Excel is 1 month',
                });
                return;
            }
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let params = this.getSearchParams();
                    params.excelFile = 'QnAReportByAnswerList';
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/qnaReportByAnswererExcel.skp`,
                            qs.stringify(params),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        
        registVerifyContents() {
            let validList = [''];
            if (validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },
        offLoadingBar() {
            this.loadingCnt++;
            if (this.loadingCnt > 3) SDLUtil.showLoadingBar(false);
        },
        clickReset(mode) {
            if (mode == 1) {
                this.modelCd = '';
                this.modelNm = '';
            } else if (mode == 2) {
                this.register = '';
                this.registerNm = '';
            } else if (mode == 3) {
                this.answerer = '';
                this.answererNm = '';
            }
        },
        searchModelPopup() {
            let searchModel = this.modelNm;
            SDLUtil.show(
                searchModelPopup, {
                    searchModel,
                    rtnFunc: (arg1, arg2, arg3, arg4, arg5) => {
                        this.modelCd = arg1;
                        this.modelNm = arg2;
                    },
                },
                {
                    width: '500px',
                    height: 'auto',
                },
            );
        },
        searchUserPopup(mode) {
            SDLUtil.show (
                searchUserPopup, {
                    rtnFunc: (arg1, arg2, arg3) => {
                        if (mode == 1) {
                            this.register   = arg1;
                            this.registerNm = arg3;
                        } else if (mode == 2) {
                            this.answerer   = arg1;
                            this.answererNm = arg3;
                        } else {

                        }
                    },
                }, {
                    width: '500px',
                    height: 'auto',
                }
            );
        },
    },
    created() {
        // 초기 카테고리1 리스트 로드
//        this.setCategory1();
    },

    mounted() {

        SDLUtil.showLoadingBar(true);
        // Processing Level
        api.getCommonCodeList('DEPT_LEVEL_CD', 'A').then(resp => {
            this.processLevels = resp;
            this.processLevel = '2'; // default value
            this.offLoadingBar();
        });

        api.getCommonCodeList('GBM_CD', 'A').then(resp => {
            this.departments = resp;
            this.offLoadingBar();
        });

        // Category
        this.loadProducts(1, { depth : 1 }); // 상세검색에서 사용

        // Subsidiary
        this.loadSubsiCodes(1, '');

        // Inquiry Type
        this.inquiryList(1);

        this.$nextTick(() => {
            let toDate = new Date();    
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
//            this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
//            this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());
            this.rangePicker = DatePicker.createRangeWithOpener(
                'from-picker-container', 'fromDate', 'icoFromDate',
                'to-picker-container', 'toDate', 'icoToDate',
                { type: 'date', locale: 'en', showToday: false },
                (new moment()).add(-1, 'years').toDate(),
                (new moment()).toDate()
            );
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
/* 사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; cursor:pointer; }
.ftBold {font-weight: bold!important;}
.subTotal {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/qnaReportByAnswererList.vue